var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-base all",staticStyle:{"min-height":"400px"}},[(_vm.u === 'c')?_c('ConfirmCustomer',{attrs:{"ck":_vm.ck,"u":_vm.u}}):_vm._e(),_vm._v(" "),(_vm.u === 'g')?_c('ConfirmGuider',{attrs:{"ck":_vm.ck,"u":_vm.u}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad5110d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ConfirmationEmail.vue
// module id = null
// module chunks = 